import React from "react";

import dayjs from "dayjs";

import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import {Stack} from "@mui/joy";
import Snackbar from '@mui/joy/Snackbar';
import Typography from "@mui/joy/Typography";
import Chip from "@mui/joy/Chip";

// components
import LetterDetail from "./LetterDetail";
import CommonCallBackButton from "../Common/CommonCallBackButton";
import BaseApi from "../../utils/BaseApi";
import {b64toBlob, downloadBlob} from "../../utils/misc";

// icons
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DownloadIcon from '@mui/icons-material/Download';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';


class LetterCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            attached: false,
        };
    }

    async copyLetter(){
        const api = new BaseApi();
        const url = `letter/${this.props.letter.id}/copy/`;
        let response = await api.get(url, {});
        if (response.status ===200){
            this.props.callBack();
        }
    }

    async attachLetter(){
        const api = new BaseApi();
        const url = `letter/${this.props.letter.id}/generate/`;
        let params = {attach: true}
        let response = await api.get(url, params);
        if (response.status ===200){
            this.setState({
                attached: true,
            })
        }
    }

    async downloadLetter(){
        const api = new BaseApi();
        const url = `letter/${this.props.letter.id}/generate/`;
        let params = {download: true}
        let response = await api.get(url, params);
        let timestamp = dayjs().format('YYYYMMDDHHmmss');
        downloadBlob(
            b64toBlob(response.data),
            `CIFRA_Letter_${this.props.letter.number}_${timestamp}.docx`,
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        )
    }

    render() {
        return(
            <Card
                size={'sm'}
            >
                <CardContent>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Stack
                            direction="row"
                            spacing={2}
                        >
                            <Typography>
                                {this.props.letter.title}
                            </Typography>
                            <Chip
                                color={'neutral'}
                            >
                                {this.props.letter.created_on}
                            </Chip>
                        </Stack>
                        <Stack
                            direction="row"
                            spacing={1}
                        >
                            <CommonCallBackButton
                                letter={this.props.letter}
                                callBack={this.copyLetter.bind(this)}
                                propsObject={'letter'}
                                propsObjectKey={'id'}
                                icon={ContentCopyIcon}
                                color={'lime'}
                            />
                            <CommonCallBackButton
                                letter={this.props.letter}
                                callBack={this.attachLetter.bind(this)}
                                propsObject={'letter'}
                                propsObjectKey={'id'}
                                icon={AttachFileIcon}
                            />
                            <Snackbar
                              anchorOrigin={{
                                  vertical: 'top',
                                  horizontal: 'center',
                              }}
                              open={this.state.attached}
                              onClose={() => (this.setState({attached: false,}))}
                            >
                                Письмо добавлено во вложения
                            </Snackbar>
                            <CommonCallBackButton
                                letter={this.props.letter}
                                callBack={this.downloadLetter.bind(this)}
                                propsObject={'letter'}
                                propsObjectKey={'id'}
                                icon={DownloadIcon}
                            />
                            <LetterDetail
                                letter={this.props.letter}
                                callBack={this.props.callBack}
                            />
                        </Stack>
                    </Stack>
                </CardContent>
            </Card>
        )
    }
}

export default LetterCard
